module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-1400.e399fae0.svg";